<template>
  <bita-modal :id="modalId" :title="title" :modal-lg="true">
    <div slot="body">
      <table class="table">
        <thead>
          <tr>
            <th scope="col">نام و نام خانواگی</th>
            <th scope="col">بازدید</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="users && users.length">
            <tr v-for="user in users" :key="user.id">
              <td>{{ user.full_name }}</td>
              <td>{{ user.seen_at || '-' }}</td>
            </tr>
          </template>
          <div class="mt-3" v-else>دیتایی رای نمایش وجود ندارد</div>
        </tbody>
      </table>
    </div>
  </bita-modal>
</template>

<script>
export default {
  props: {
    modalId: {},
    title: {},
    users: {},
  },
};
</script>
